import { useRef, useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip"; // or your tooltip component

function TrimmableText({ text }) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const textStyle = {
    display: "inline-block",
    maxWidth: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    verticalAlign: "middle",
  };

  const textElement = (
    <b ref={textRef} style={textStyle}>
      {text}
    </b>
  );

  return isTruncated ? (
    <Tooltip title={text}>{textElement}</Tooltip>
  ) : (
    textElement
  );
}

export default TrimmableText;
